import { AfterViewChecked, ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { ConfirmDialogComponent } from '@ml/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomerLocationModalComponent } from '@ml/shared/components/customer-location-modal/customer-location-modal.component';
import { GoogleMapsService } from '@ml/shared/services/google-maps.service';
import { Task } from '@ml/tasks/types/classes';
import { User } from '@ml/core/types/classes';
import { OrderLocationStatusDialogComponent } from '@ml/shared/containers/order-location-status-dialog/order-location-status-dialog.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Order, OrderStatus } from '@ml/orders/types/order';
import { MediaObserver } from '@angular/flex-layout';
import { LocationsMoveDialogComponent } from '../locations-move-dialog/locations-move-dialog.component';
var OrderLocationsTableComponent = /** @class */ (function () {
    function OrderLocationsTableComponent(dialog, googleMapsService, cdr, mediaObserver, matDialog) {
        this.dialog = dialog;
        this.googleMapsService = googleMapsService;
        this.cdr = cdr;
        this.mediaObserver = mediaObserver;
        this.matDialog = matDialog;
        this.canEdit = true;
        this.canDrag = false;
        this.add = new EventEmitter();
        this.addCustomerLocations = new EventEmitter();
        this.addManualLocation = new EventEmitter();
        this.editLocation = new EventEmitter();
        this.remove = new EventEmitter();
        this.updatePositions = new EventEmitter();
        this.displayedColumns = ['id', 'name', 'status', 'preview', 'navigation'];
    }
    OrderLocationsTableComponent.prototype.ngOnInit = function () {
        if (this.canDrag) {
            this.displayedColumns.push('move');
        }
        if (this.canEdit) {
            this.displayedColumns.push('actions');
        }
    };
    OrderLocationsTableComponent.prototype.ngAfterViewChecked = function () {
        this.cdr.detectChanges();
    };
    Object.defineProperty(OrderLocationsTableComponent.prototype, "canAddLocation", {
        get: function () {
            return (this.order &&
                this.order.status !== OrderStatus.READY_ACCOUNTING &&
                this.order.status !== OrderStatus.INVOICE_ISSUED &&
                this.order.status !== OrderStatus.PAID &&
                this.order.status !== OrderStatus.CANCELLED);
        },
        enumerable: true,
        configurable: true
    });
    OrderLocationsTableComponent.prototype.dropTable = function (event) {
        var prevIndex = this.orderLocations.findIndex(function (d) { return d.id === event.item.data.id; });
        var orderLocations = this.orderLocations.slice();
        moveItemInArray(orderLocations, prevIndex, event.currentIndex);
        this.orderLocations = orderLocations.slice();
        var updatePositions = this.orderLocations.map(function (orderLocation, index) { return ({
            id: orderLocation.id,
            position: index
        }); });
        this.updatePositions.emit(updatePositions);
    };
    OrderLocationsTableComponent.prototype.onSelectLocation = function (taskLocation) {
        var _this = this;
        if (!this.connection) {
            return;
        }
        var task = this.tasks.find(function (value) { return value.id === taskLocation.task; });
        this.dialog
            .open(OrderLocationStatusDialogComponent, {
            width: '400px',
            maxWidth: '100vw',
            data: {
                task: task,
                taskLocation: taskLocation
            }
        })
            .afterClosed()
            .subscribe(function (_taskLocation) {
            _this.tasks = _this.tasks.slice();
            _this.cdr.detectChanges();
        });
    };
    OrderLocationsTableComponent.prototype.onEdit = function (orderLocation) {
        var _this = this;
        var isTablet = this.mediaObserver.isActive('lg');
        this.matDialog
            .open(CustomerLocationModalComponent, {
            width: isTablet ? '800px' : '100vw',
            maxWidth: '100vw',
            data: {
                location: orderLocation.location
            }
        })
            .afterClosed()
            .subscribe(function (_value) {
            orderLocation.location = _value;
            _this.cdr.detectChanges();
            if (_value) {
                _this.editLocation.emit(_value);
            }
        });
    };
    OrderLocationsTableComponent.prototype.getTasks = function (orderLocation) {
        if (!this.tasks) {
            return [];
        }
        return this.tasks.filter(function (task) {
            var locations = task.locations;
            return (locations.findIndex(function (value) {
                if (typeof value.orderLocation === 'number') {
                    return value.orderLocation === orderLocation.id;
                }
                return value.orderLocation.id === orderLocation.id;
            }) >= 0);
        });
    };
    OrderLocationsTableComponent.prototype.onAddManualLocation = function () {
        this.addManualLocation.emit();
    };
    OrderLocationsTableComponent.prototype.onAddCustomerLocation = function () {
        this.addCustomerLocations.emit();
    };
    OrderLocationsTableComponent.prototype.onAdd = function () {
        this.add.emit();
    };
    OrderLocationsTableComponent.prototype.onPreview = function (orderLocation) {
        var isTablet = this.mediaObserver.isActive('lg');
        this.dialog.open(CustomerLocationModalComponent, {
            width: isTablet ? '800px' : '100vw',
            maxWidth: '100vw',
            data: {
                location: orderLocation.location,
                disable: true
            }
        });
    };
    OrderLocationsTableComponent.prototype.onNavigation = function (orderLocation) {
        var location = orderLocation.location;
        this.googleMapsService.navigateTo(location);
    };
    OrderLocationsTableComponent.prototype.onMove = function (orderLocation) {
        var _this = this;
        var prevIndex = this.orderLocations.findIndex(function (d) { return d.id === orderLocation.id; });
        var orderLocations = this.orderLocations.slice();
        var isTablet = this.mediaObserver.isActive('lg');
        var dialogRef = this.dialog.open(LocationsMoveDialogComponent, {
            width: isTablet ? '800px' : '100vw',
            maxWidth: '100vw',
            data: {
                orderLocationToMove: orderLocation,
                orderLocations: this.orderLocations
            }
        });
        dialogRef.afterClosed().subscribe(function (currentIndex) {
            if (currentIndex === undefined) {
                return;
            }
            moveItemInArray(orderLocations, prevIndex, currentIndex);
            _this.orderLocations = orderLocations.slice();
            var updatePositions = _this.orderLocations.map(function (newOrderLocation, index) { return ({
                id: newOrderLocation.id,
                position: index
            }); });
            _this.updatePositions.emit(updatePositions);
        });
    };
    OrderLocationsTableComponent.prototype.onRemove = function (location) {
        var _this = this;
        var isTablet = this.mediaObserver.isActive('lg');
        this.dialog
            .open(ConfirmDialogComponent, {
            width: isTablet ? '800px' : '100vw',
            maxWidth: '100vw',
            data: {
                title: "confirm-remove-location"
            }
        })
            .afterClosed()
            .subscribe(function (accept) {
            if (accept) {
                _this.remove.emit(location);
            }
        });
    };
    return OrderLocationsTableComponent;
}());
export { OrderLocationsTableComponent };
